import { queryOptions, useQuery, useQueryClient } from '@tanstack/react-query'
import { getCurrentUser } from '@/domains/user/api'
import { authQueryOptions } from '@/domains/auth/queries'

const USER_QUERY_STALE_TIME = 1000 * 60 * 5

export const userQueryOptions = (accessToken: string) =>
  queryOptions({
    queryKey: ['user'] as const,
    queryFn: () => getCurrentUser({ access_token: accessToken }),
    staleTime: USER_QUERY_STALE_TIME,
  })

export function useUserQuery() {
  const queryClient = useQueryClient()
  const authData = queryClient.getQueryData(authQueryOptions('').queryKey)
  const accessToken = authData?.access_token

  return useQuery({
    ...userQueryOptions(accessToken ?? ''),
    enabled: !!accessToken,
  })
}
